const BusinessPath = {
  TERMS_CONDITION: "https://socashless.com/terms-conditions",
  PRIVACY: "https://socashless.com/privacy/",
  COMMUNITY_GUIDELINES: "https://socashless.com/",
};

export default BusinessPath;
